/* eslint-disable @typescript-eslint/naming-convention */
import type { fuelTypeMessagesScope } from '../../Services/Vehicle/Vehicle.messages';
import { type MessageOptions, transformOptionsByMessageIds } from './TransformOptionsByMessageId';

export type FuelTypeMessageId = keyof typeof fuelTypeMessagesScope;

const FUEL_TYPES_BY_MESSAGE_ID: Record<FuelTypeMessageId, MessageOptions> = {
  petrol: {
    ids: ['petrol', 'essence'],
    label: 'Petrol',
  },
  diesel: {
    ids: ['diesel'],
    label: 'Diesel',
  },
  ethanol: {
    ids: ['ethanol'],
    label: 'Ethanol',
  },
  hybrid: {
    ids: ['hybrid', 'hybride'],
    label: 'Hybrid',
  },
  hybrid_diesel: {
    ids: ['hybrid_diesel'],
    label: 'Hybrid - Diesel',
  },
  hybrid_petrol: {
    ids: ['hybrid_petrol'],
    label: 'Hybrid - Benzin',
  },
  electric: {
    ids: ['electric', 'electrique'],
    label: 'Electric',
  },
  gas: {
    ids: ['gas', 'gpl'],
    label: 'Gaz',
  },
  lpg: {
    ids: ['lpg'],
    label: 'LPG',
  },
  other: {
    ids: ['other'],
    label: 'Autres',
  },
};

const FUEL_TYPES = transformOptionsByMessageIds(FUEL_TYPES_BY_MESSAGE_ID);

export { FUEL_TYPES };
